var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyAvatarBoy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4504_156206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.7988 87.0663L82.7983 87.0667C74.0673 94.8038 62.5897 99.5 50 99.5C37.4302 99.5 25.952 94.8039 17.2008 87.0856C6.94955 78.0033 0.5 64.7522 0.5 50C0.5 22.658 22.658 0.5 50 0.5C77.342 0.5 99.5 22.658 99.5 50C99.5 64.7526 93.05 78.0039 82.7988 87.0663Z",
    fill: "#FDFDFD",
    stroke: "#FF9053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2138 83.3859C76.6547 81.4764 72.009 78.3072 66.95 75.9646C61.8909 73.6418 58.9185 68.189 59.7256 62.6969C59.7256 62.6182 59.7453 62.5394 59.7649 62.441C59.7649 62.441 71.2807 54.6457 69.6862 47.0473C69.6862 47.0473 70.0405 47.067 70.572 47.0276C75.6508 46.5552 75.9657 38.9961 70.9461 38.189C70.9067 38.189 70.8476 38.1694 70.8083 38.1694L70.6508 37.3426C72.1862 31.9686 75.9264 15.689 64.6075 17.2638C64.6075 17.2638 56.4776 3.81896 39.2925 10.2953C22.0878 16.752 26.576 32.1654 26.576 32.1654L28.702 38.3072C24.076 39.4489 24.509 46.5946 29.4303 47.0473C29.9618 47.0867 30.3358 47.067 30.3358 47.067C28.7216 54.6654 40.2374 62.4607 40.2374 62.4607C40.2571 62.5591 40.2571 62.6379 40.2768 62.7166C41.0642 68.2087 38.0917 73.6615 33.0523 75.9843C27.9736 78.3268 23.3476 81.5158 20.7886 83.4056C19.2531 84.5276 17.8949 85.8859 16.8516 87.4804C25.7098 95.256 37.3043 100 50.0012 100C62.7177 100 74.3122 95.256 83.1311 87.441C82.1075 85.8662 80.7492 84.5079 79.2138 83.3859Z",
    fill: "#F79009"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4504_156206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAvatarBoy);
export default __webpack_public_path__ + "static/media/empty-avatar-boy.60f9514d2373a1007c9adbe503b8c628.svg";
export { ForwardRef as ReactComponent };